import { css } from 'styled-components';

export const lastMinuteDealsGradient = css`linear-gradient(90deg, ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary}, ${({ theme }) => theme.kallisto.color.common.special.flashSales[400]})`;

export const flashSalesGradient = css`linear-gradient(90deg, ${({ theme }) => theme.kallisto.color.common.special.flashSales[500]}, ${({ theme }) => theme.kallisto.color.common.special.flashSales[400]})`;

export const lastminuteDealsGradientOnText = css`
  // fallback color
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};

  @supports (background-clip: text) {
    background: ${lastMinuteDealsGradient};
    background-clip: text;
    color: transparent;
  }
`;

export const lastminuteDealsGradientOnButton = css`
  background: ${lastMinuteDealsGradient} !important;
  border: none;

  &:hover {
    background:
      linear-gradient(
          90deg,
          ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary} 0%,
          ${({ theme }) => theme.kallisto.color.common.special.flashSales[400]} 119.89%
        )
        padding-box,
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)) border-box !important;
    border: none;
  }
`;
